// extracted by mini-css-extract-plugin
export var active = "_lo-2";
export var recordingDot = "_lo-1";
export var recordingIndicator = "_lo-0";